<template>
    <div class="about">
        <about-header>关于协会</about-header>
        <ul class="list">
            <li 
                class="lis" 
                :class="{'active': current == index}"
                v-for="(item,index) in list"
                @click="handleItemClick(index)" 
                :key="item.id">
                {{item.title}}
            </li>
        </ul>
        <div class="container">
            <about-introduction v-if="current == 0"></about-introduction>
            <about-rule v-if="current == 1"></about-rule>
            <about-architecture v-if="current == 2"></about-architecture>
            <about-party v-if="current == 3"></about-party>
            <about-admission v-if="current == 4"></about-admission>
            <about-contact v-if="current == 5"></about-contact>
        </div>
    </div>
</template>

<script>
import AboutHeader from '../../components/Header';
import AboutIntroduction from './components/Introduction';  //简介
import AboutRule from './components/Rule';  //章程
import AboutArchitecture from './components/Architecture';  //架构
import AboutParty from './components/Party';    //党建
import AboutAdmission from './components/Admission';    //入会
import AboutContact from './components/Contact';    //联系我们
export default {
    name: "About",
    components: {
        AboutHeader,
        AboutIntroduction,
        AboutRule,
        AboutArchitecture,
        AboutParty,
        AboutAdmission,
        AboutContact
    },
    data() {
        return {
            list: [
                {
                    id: 1,
                    title: '协会简介'
                },{
                    id: 2,
                    title: '协会章程'
                },{
                    id: 3,
                    title: '组织架构'
                },{
                    id: 4,
                    title: '党建工作'
                },{
                    id: 5,
                    title: '入会流程'
                },{
                    id: 6,
                    title: '联系我们'
                }
            ],
            current: 0,
        }
    },
    methods: {
        handleItemClick(index) {
            this.current = index
        }
    },
};
</script>

<style scoped>
.about{
    background: #F2F3F7;
}
.container{
    height: calc(100vh - 1rem);
    overflow: auto;
}
/* 列表导航 */
.list{
    display: flex;
    background: #fff;
}
.list .lis{
    width: 16.6%;
    height: .8rem;
    line-height: .8rem;
    text-align: center;
}
.list .active{
    color: #fff;
    background: #FF9000;
}
</style>